<template>
  <div class="no-application-selected">
    <h3>No application selected 😟</h3>
  </div>
</template>

<script>
  export default {
    name: 'NoApplicationSelected'
  }
</script>

<style lang="scss">
  @import "../../styles/components/mediaQueries.scss";

  .no-application-selected {
    height: calc(100vh - 120px);
    display: flex;
    justify-content: center;
    align-items: center;

    h3 {
      font-size: 30px;

      @include media-sm {
        font-size: 18px;
      }
    }
  }
</style>